import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { AddAdivicateComponent } from './legalmatter/createlegalmatter/matter-info/add-adivicate/add-adivicate.component';
import { AddTagComponent } from './legalmatter/createlegalmatter/matter-info/add-tag/add-tag.component'
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CdkMenuModule } from '@angular/cdk/menu';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { ConfirmationDialogComponent } from './legalmatter/createlegalmatter/matter-groups/matter-groups.component';
import { CreategeneralmatterComponent } from './genaralmatter/creategeneralmatter/creategeneralmatter.component';
import { CreatelegalmatterComponent } from './legalmatter/createlegalmatter/createlegalmatter.component';
import { DialogModule } from '@angular/cdk/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ExternalmatterComponent } from './legalmatter/externalmatter/externalmatter.component';
import { ExternalviewdetailsComponent } from './legalmatter/externalviewdetails/externalviewdetails.component';
import { GeneralMatterInfoComponent } from './genaralmatter/creategeneralmatter/general-matter-info/general-matter-info.component';
import { GeneralViewDetailsComponent } from './genaralmatter/generalviewdetails/generalviewdetails.component';
import { GeneralinternalviewdetailsComponent } from './genaralmatter/generalinternalviewdetails/generalinternalviewdetails.component';
import { GeneralleavepageComponent } from './genaralmatter/creategeneralmatter/generalleavepage/generalleavepage.component';
import { InternalmatterComponent } from './legalmatter/internalmatter/internalmatter.component';
import { LeavepageComponent } from './legalmatter/createlegalmatter/leavepage/leavepage.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MatterClientsComponent } from './legalmatter/createlegalmatter/matter-clients/matter-clients.component';
import { MatterComponent } from './matter.component';
import { MatterDocumentsComponent } from './legalmatter/createlegalmatter/matter-documents/matter-documents.component';
import { MatterGroupsComponent } from './legalmatter/createlegalmatter/matter-groups/matter-groups.component';
import { MatterInfoComponent } from './legalmatter/createlegalmatter/matter-info/matter-info.component';
import { MatterRoutingModule } from './matter-routing.module';
import { MatterTeamMembersComponent } from './legalmatter/createlegalmatter/matter-team-members/matter-team-members.component';
// import { FilterPipeModule } from 'ngx-filter-pipe';
import { NgModule } from '@angular/core';
import { NgxFileDropModule } from 'ngx-file-drop';
import { NgxSpinnerModule } from 'ngx-spinner';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ToastrModule } from 'ngx-toastr';
import { ViewDetailsComponent } from './legalmatter/viewdetails/viewdetails.component';
import { ViewGeneralmatterComponent } from './genaralmatter/viewgenaralmatter/viewgenaralmatter.component';
import { ViewlegalmatterComponent } from './legalmatter/viewlegalmatter/viewlegalmatter.component';
// import {MatDatepickerModule} from '@angular/material/datepicker';
// import {MatInputModule} from '@angular/material/input';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SharedModule } from '../shared/shared.module';
//import { CalenderModule } from '../calender/calender.module';
import { ViewEventComponent } from '../calender/viewevent/viewevent.component';


@NgModule({
  declarations: [
    MatterComponent,
    ViewlegalmatterComponent,
    ExternalmatterComponent,
    InternalmatterComponent,
    CreatelegalmatterComponent,
    MatterTeamMembersComponent,
    MatterGroupsComponent,
    MatterDocumentsComponent,
    MatterClientsComponent,
    MatterInfoComponent,
    AddAdivicateComponent,
    AddTagComponent,
    ViewDetailsComponent,
    ViewGeneralmatterComponent,
    CreategeneralmatterComponent,
    GeneralMatterInfoComponent,
    GeneralViewDetailsComponent,
    ExternalviewdetailsComponent,
    GeneralinternalviewdetailsComponent,
    ConfirmationDialogComponent,
    LeavepageComponent,
    GeneralleavepageComponent
  ],
  imports: [
    RouterModule,
    FormsModule,
    AutocompleteLibModule,
    MatAutocompleteModule,
    MatterRoutingModule,
    NgxSpinnerModule,
    CommonModule,
    ReactiveFormsModule,
    //FilterPipeModule,
    SharedModule,
    //CalenderModule,
    ViewEventComponent,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    A11yModule,
    CdkAccordionModule,
    ClipboardModule,
    CdkMenuModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    DragDropModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    OverlayModule,
    PortalModule,
    ScrollingModule,
    DialogModule,
    NgxFileDropModule,
    MatDialogModule,
    MatFormFieldModule,
    MatButtonModule,
    MatRadioModule,
    ToastrModule.forRoot(),
    BsDatepickerModule.forRoot(),
  ],
  providers: [],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class MatterModule { }
